import courses from "./courses.json";
import hazards from "./hazards.json";
import difficulty from "./difficulty.json";
import modes from "./modes.json";
import obstacles from "./obstacles.json";
import player from "./player.json";
import scoring from "./scoring.json";
import tricks from "./tricks.json";
import type { GameConfig } from "./types";
import zones from "./zones.json";

export const config = {
    player,
    obstacles,
    zones,
    courses,
    difficulty,
    tricks,
    modes,
    hazards,
    scoring,
} as unknown as GameConfig;
